import React, { useState, useContext } from 'react';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import GoogleMapContext from '../../GoogleMapComponent/GoogleMapContext';
import { copyToClipboard, openLinkInNewTab } from '../../helper';
import { toasterMsg } from '../../Toaster/Toaster';
import GoogleAddressComponent from './GoogleAddressComponent';
import GooglePlacesNearMe from './GooglePlacesNearMe';

export function Google(props) {
  const { t } = useTranslation('common');
  const { fromForm, dataIndex, DPPstate, editingInput, deleteItem, dppAddEditAccess, isProductArchived, placesNearMe } = props;
  const [expandOpenHours, setExpandOpenHours] = useState([]);
  const [toggleMap, handleToogleOfMap] = useState(true);
  const [isPlaceNearToggled, handleTogglePlacesNear] = useState(false);
  const { currentCoordinates } = useContext(GoogleMapContext);

  // Toggle group expansion
  const handleToggleOPenHours = (i) => {
    let cloneExpand = cloneDeep(expandOpenHours);
    if (cloneExpand?.includes(i)) {
      cloneExpand = cloneExpand.filter((vl) => vl !== i);
    } else {
      cloneExpand.push(i);
    }
    setExpandOpenHours(cloneExpand);
  };
  const handleToggleMap = () => {
    handleToogleOfMap(!toggleMap);
  };

  const handleOpenGoogleMaps = (destinationCoorinates) => {
    if (destinationCoorinates) {
      const origin = currentCoordinates || { lat: 40.712776, lng: -74.005974 };
      const destination = destinationCoorinates;
      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  const copyPhoneNumber = (number) => {
    copyToClipboard(number);
    toasterMsg('Copyied to clipboard', 'success');
  };
  const checkAddressExist = props?.addresses?.length ? props?.addresses?.[0]?.placeDetails : null;

  const returnGoogleJsx = () => {
    if (props?.isAddressType === 'addresses') {
      return (
        <div>
          {props?.addresses?.map((map, i) => (
            <div key={i}>
              <GoogleAddressComponent
                map={map}
                i={i}
                toggleMap={toggleMap}
                expandOpenHours={expandOpenHours}
                handleToggleOpenHours={handleToggleOPenHours}
                openLinkInNewTab={openLinkInNewTab}
                copyPhoneNumber={copyPhoneNumber}
                handleOpenGoogleMaps={handleOpenGoogleMaps}
                DPPstate={DPPstate}
              />
            </div>
          ))}
        </div>
      );
    }
    if (props?.isAddressType === 'nearPlaces') {
      return (
        <div>
          <GooglePlacesNearMe
            relatedPlacesNearMe={props?.relatedPlacesNearMe || []}
            placesNearMe={placesNearMe}
            isAddressType={props?.isAddressType}
            isPlaceNearToggled={isPlaceNearToggled}
            expandOpenHours={expandOpenHours}
            handleToggleOpenHours={handleToggleOPenHours}
            openLinkInNewTab={openLinkInNewTab}
            copyPhoneNumber={copyPhoneNumber}
            handleOpenGoogleMaps={handleOpenGoogleMaps}
            DPPstate={DPPstate}
          />
        </div>
      );
    }
    return null;
  };
  const renderToggleIcon = () => {
    if (props.isAddressType === 'addresses' && checkAddressExist) {
      return (
        <span
          id="collapsible-address"
          className={`icon-new-down-arrow-icon drop-icon ml-16 f-20 ${!toggleMap ? 'rotated' : ''}`}
          onClick={() => handleToggleMap()}
        />
      );
    }
    if (props.isAddressType === 'nearPlaces' && props?.placesNearMe) {
      return (
        <span
          id="collapsible-near"
          className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${isPlaceNearToggled ? 'rotated' : ''}`}
          onClick={() => handleTogglePlacesNear(!isPlaceNearToggled)}
        />
      );
    }
    return null; // Return null if none of the conditions are met
  };

  return (
    <div className="heading-control">
      {!props?.placesNearMe && !props?.addresses?.[0]?.address ? <div className="empty-source">{t('DPP.CONTROL.GOOGLE.GOOGLE_PLACEHOLDER')}</div> : <>&nbsp;</>}
      {!props?.isAddressType ? <div className="empty-source">{t('DPP.CONTROL.GOOGLE.GOOGLE_PLACEHOLDER')}</div> : null}

      <div className="d-flex align-items-center">
        <h4 className="google-title">{props?.title}</h4>
        {renderToggleIcon()}
      </div>

      {returnGoogleJsx()}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default Google;
